
    @if (!customizableMode) {
        <p-card>
        <div class="padding15">
            <div class="module-flex-row-with-space">
                <div class="module-title">
                    <div class="module-title-label" >Rebalances</div>
                    <img class="svg-arrow-right-circle" [routerLink]="['/rebalancing/rebalance-results']" src="../../assets/images/arrow-right-circle-outline.svg" >
                </div>
                <div>
                    <a (click)="showCreateRebalance()" style="font-size: 14px;color:#006E99!important;">Create a Rebalance</a>
                </div>
            </div>

            @if (!data) {
                <div class='loading-spinner'></div>
            }
            @if (data) {
                <div [class.rebalance-module-single-view]="singleWidth" [class.rebalance-module-double-view]="!singleWidth" style="margin-top: 30px;">
                    <div class="rebalance-module-table-header">
                        <div class="rebalance-module-table-col1">Portfolio</div>
                        <div class="rebalance-module-table-col2">Type</div>
                        <div class="rebalance-module-table-col3">Total</div>
                        <div class="rebalance-module-table-col4">Orders</div>
                        <div class="rebalance-module-table-col5">Approved</div>
                        <div class="rebalance-module-table-col6"></div>
                    </div>
                    @for (item of data; track item.rebalPkgId) {
                        <div class="rebalance-module-table-row">
                            <div class="rebalance-module-table-col1 truncate" tooltip [tooltipTitle]="item.rebalName" [tooltipRequiresTruncation]="true" tooltipPosition="right" [tooltipHorizontalOffset]="0">{{item.rebalName}}</div>
                            <div class="rebalance-module-table-col2 truncate" tooltip [tooltipTitle]="item.rebalTypeDesc" [tooltipRequiresTruncation]="true" tooltipPosition="right" [tooltipHorizontalOffset]="0">{{item.rebalTypeDesc}}</div>
                            <div class="rebalance-module-table-col3">{{item.totalPorts | number}}</div>
                            <div class="rebalance-module-table-col4">{{item.totalTradePorts | number}}</div>
                            <div class="rebalance-module-table-col5">{{item.totalApprovedPorts | number}}</div>
                            <div class="rebalance-module-table-col6">
                                @if (singleWidth) {
                                    <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" style="width: 16px;" (click)="showRebalanceResultSummary(item.rebalPkgId)">
                                }
                                @else {
                                    <a style="color:#006E99!important;" (click)="showRebalanceResultSummary(item.rebalPkgId)">View</a>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
        </p-card>
    }
    @if (customizableMode) {
        <div style="padding:25px 10px;">
            <table>
                <tr>
                    <td style="width: 30%;"><div class="skeleton-styles-rectangle" style="width: 99%;"></div></td>
                    <td style="width: 25%;"><div class="skeleton-styles-rectangle" style="width: 95%;"></div></td>
                    <td style="width: 20%;"><div class="skeleton-styles-rectangle" style="width: 80%;"></div></td>
                    <td style="width: 10%;"><div class="skeleton-styles-rectangle" style="width: 60%;"></div></td>
                    <td style="width: 15%;"><div class="skeleton-styles-rectangle" style="width: 65%;"></div></td>
                </tr>
                @for (i of [].constructor(9); track $index) {
                    <tr>
                        <td ><div class="skeleton-styles-rectangle" style="width: 99%;"></div></td>
                        <td ><div class="skeleton-styles-rectangle" style="width: 80%;"></div></td>
                        <td ><div class="skeleton-styles-rectangle" style="width: 60%;"></div></td>
                        <td ><div class="skeleton-styles-rectangle" style="width: 40%;"></div></td>
                        <td >
                            <div  class="module-flex-row-with-space">
                                <div class="skeleton-styles-rectangle" style="width: 40%;"></div>
                                @if (singleWidth) {
                                    <div class="skeleton-styles-circle"></div>
                                }
                                @if (!singleWidth) {
                                    <div class="skeleton-styles-rectangle" style="width:30px;"></div>
                                }
                            </div>
                        </td>
                    </tr>
                }
            </table>
        </div>
    }


